import request from '@/utils/request'

// AMC 教学计划 APIs -> /api/amc/teaching-plan

export function getTeachingPlans(courseId) {
  return request({
    url: `/teaching-plan/course/${courseId}`,
    method: 'get'
  })
}

export function createTeachingPlan(data) {
  return request({
    url: '/teaching-plan',
    method: 'post',
    data
  })
}

export function updateTeachingPlan(id, data) {
  return request({
    url: `/teaching-plan/${id}`,
    method: 'put',
    data
  })
}

export function deleteTeachingPlan(id) {
  return request({
    url: `/teaching-plan/${id}`,
    method: 'delete'
  })
}

export function publishTeachingPlan(id) {
  return request({
    url: `/amc/teaching-plan/${id}/publish`,
    method: 'post'
  })
}

export function unpublishTeachingPlan(id) {
  return request({
    url: `/amc/teaching-plan/${id}/unpublish`,
    method: 'post'
  })
}
